import { animate, inView, stagger, delay } from "motion"

// Animation - Header
animate(
    '.logo',
    { opacity: [0,1], y: [20, 0] },
    {
        duration:0.5,
        easing: [0.17, 0.55, 0.55, 1],
    }
);
animate(
    '.nav__links li',
    { opacity: [0,1], y: [20, 0] },
    {
        delay: stagger(0.2),
        easing: [0.17, 0.55, 0.55, 1],
    }
);
// Animation - Hero
inView(".hero", ({target})=>{
    const heroContentH2  = target.querySelector('.hero__content h2');
    if (!heroContentH2) {
    return () => {}; // Return an empty cleanup function
  }
    animate(
        heroContentH2,
        { opacity: 1, y: [-20, 0] },
        {
            duration: 0.5,
            easing: [0.17, 0.55, 0.55, 1],
        }
    );
    return () => {
        animate(heroContentH2, { opacity: 0, y: -100 });
    }
});

inView(".hero__blob__right.--desktop img", ({target})=>{
    animate(target,
        { opacity: [0,1], y: [100, 0] },
        {
            duration: 0.5,
            delay:0.5,
            easing: [0.17, 0.55, 0.55, 1],
     });
});

inView(".hero__blob__left.--desktop img", ({target})=>{
    animate(target,
        { opacity: [0,1], y: [100, 0] },
        {
            duration: 0.5,
            easing: [0.17, 0.55, 0.55, 1],
     });
    //  return ()=>{ };
    // return () => animate(target, { opacity: 0, y: -100 });
});

inView(".hero__vectors ", ({target})=>{
    delay(() => {
        animate(".hero__vectors .hero__vectors_img",
            { opacity:[0, 1], y: [100, 0] },
            {
                delay: stagger(0.2), //  4 span 
                easing:"circInOut",
        });
    },0.7) // Until above animation finish
});


inView(".hero__heading.--title ", ({target})=>{
    delay(() => {
        animate(".hero__heading.--title .title",
            { opacity:[0, 1], y: [100, 0] },
            {
                delay: stagger(0.2), //  4 span 
                easing:"circInOut",
        });
    },0.7) // Until above animation finish
});


// Animation - Discover
inView(".discover__content_w", ({target})=>{
    animate(".discover__image img",
        { opacity: [0,1], y: [100, 0] },
        {
            duration: 0.5,
            easing:"easeInOut",
            delay:0.2
     });
});


// Animation - Dynamic Text
inView(".dynamic-text", ({target})=>{
    animate(target,
        { opacity: [0,1], y: [100, 0] },
        {
            duration: 0.5,
            easing:"easeInOut",
     });
    return () => animate(target, { opacity: 0, y: -100 });
});

inView(".hero__heading__title.--about", ({target})=>{
    animate(target,
        { opacity: [0,1], y: [100, 0] },
        {
            duration: 0.5,
            easing:"easeInOut",
     });
    return () => animate(target, { opacity: 0, y: -100 });
});


// Animation - Tabs 
inView(".selling_tabs__content .tab-content", ({target})=>{
    animate(target,
     { opacity: [0,1], y: [100, 0] },
        {
            easing:"easeInOut",
     });
});


// inView(".richtext", ({target})=>{
//     animate(".richtext p",
//         {y: [20, 0] },
//         {
//             delay: stagger(0.2),
//             easing:"circInOut",
//      });
// });


// Animation - About 
inView(".about__title", ({target})=>{
    animate(target,
        { opacity: [0,1], y: [100, 0] },
        {
            duration: 0.5,
            easing:"easeInOut",
     });
});

inView(".about__blobs_right img", ({target})=>{
    animate(target,
        { opacity: [0,1], x: [100, 0] },
        {
            duration: 0.5,
            easing:"easeInOut",
     });
     return ()=>{ };
    // return () => animate(target, { opacity: 0, x: -100 });
});

inView(".about__blobs_left img", ({target})=>{
    animate(target,
        { opacity: [0,1], x: [-100, 0] },
        {
            duration: 0.5,
            delay:0.3,
            easing:"easeInOut",
     });
    //  return ()=>{ };
    // return () => animate(target, { opacity: 0, x: -100 });
});

inView(".about__blobs_or", ({target})=>{
    animate(target,
        { opacity: [0,1], y: [-100, 0] },
        {
            duration: 0.5,
            delay:0.4,
            easing:"easeInOut",
     });
     return ()=>{ };
    // return () => animate(target, { opacity: 0, y: -100 });
});


// Animation - Register 
inView(".register__title", ({target})=>{
    animate(target,
        { opacity: [0,1], y: [100, 0] },
        {
            duration: 0.5,
            easing:"easeInOut",
     });
});

inView(".register", ({target})=>{
    animate(".register__form",
        { opacity: [0,1], y: [100, 0] },
        {
            duration: 0.5,
            delay:0.5,
            easing:"easeInOut",
     });
     return ()=>{ };
    // return () => animate(".register__form", { opacity: 0, y: -100 });
});


// Animation - Footer 
inView(".footer", ({target})=>{
    animate(".footer__content",
        { opacity: [0,1], y: [100, 0] },
        {
            duration: 0.5,
            easing:"easeInOut",
     });
});


// Aniamtion
inView(".slide-up",({target})=>{
    animate(target,
        { opacity: [0,1], y: [200, 0] },
        {
            duration: 0.5,
            easing:"easeInOut",
     });
});


animate(".ani-get-in",
    { opacity: [0,1], x: [200, 0] },
    {
        duration: 0.5,
        easing:"easeInOut",
    });

// Feautred Card Stagger
inView(".ani-slides-up",({target})=>{
    animate(".ani-slides-up .ani-slide", 
        { opacity:[0, 1], y: [100, 0] },
            {
                delay: stagger(0.3), //  3 span 
                easing:"circInOut",
        })
})



